import { Component, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Pet } from 'src/app/interfaces/pet';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { UserService } from 'src/app/services/user/user.service';
import { Subscription } from 'rxjs';
import { RegistrationProgressService } from 'src/app/services/registration-progress/registration-progress.service';
import { RegistrationFlowService } from 'src/app/services/registration-flow/registration-flow.service';
import { Router } from '@angular/router';
import { CloudinaryService } from 'src/app/services/cloudinary/cloudinary.service';
import { ClickEventNumbersEnum } from 'src/app/interfaces/clickEventNumbers';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-authenticated-header',
  templateUrl: './authenticated-header.component.html',
  styleUrls: ['./authenticated-header.component.scss'],
})
export class AuthenticatedHeaderComponent implements OnDestroy {
  public displayOnlyUserIconDropdown: boolean = true;
  public displayUserIconDropdown: boolean = true;

  ClickEventNumbersEnum = ClickEventNumbersEnum;
  isBrowser: boolean;

  private _subs: Subscription[] = [];

  constructor(
    public authManager: AuthManagerService,
    private userService: UserService,
    private registrationProgressService: RegistrationProgressService,
    private registrationFlowService: RegistrationFlowService,
    private router: Router,
    private cloudinaryService: CloudinaryService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    // registrationFinished reads the membership and welcome gift progress from the steps
    this._subs.push(this.registrationFlowService.loadSteps().subscribe());
  }

  get pets(): Pet[] {
    return this.userService.user
      ? this.userService.filterAliveRegisteredPets(this.userService.user.pets)
      : [];
  }

  get registrationFinished(): boolean {
    if (!this.userService.user) return true;
    const progress =
      this.registrationProgressService.getRegistrationProgressData(
        this.userService.user
      );
    return (
      progress.isFullNameRegistrationCompleted &&
      progress.isMembershipSelectionCompleted &&
      progress.isPetChipNumberRegistrationCompleted &&
      progress.isWelcomePackSelectCompleted
    );
  }

  get completeButtonVisible(): boolean {
    return (
      this.router.url === '/identibase-plus' ||
      this.router.url === '/identialert'
    );
  }

  navigateToStep3OfRegistration() {
    this.router.navigate(['/account/membership-options']);
  }

  ngOnDestroy(): void {
    this._subs.forEach((it) => it.unsubscribe());
  }

  opened(isOpened: boolean): void {
    if (this.isBrowser && isOpened) {
      window.analytics.track('header::menu::opened');
    }
  }

  public getPetImageUrl(petImageId: string): string {
    return this.cloudinaryService.getImageUrl(petImageId, 88, 88, null);
  }

}
